module.exports = __webpack_public_path__ + "static/feature_1-38884549fbd83d949948e6e009e97014.png";